export const savedRevisionToAutoSelect = ({
  hasUnsavedChanges,
  userPicked,
  isFetching,
  dataUpdatedAt,
  dataUpdatedAtOnOpen,
  latestId,
}: {
  hasUnsavedChanges: boolean;
  userPicked: boolean;
  isFetching: boolean;
  dataUpdatedAt: number;
  dataUpdatedAtOnOpen: number;
  latestId: string | null;
}) => {
  if (hasUnsavedChanges || userPicked || isFetching || !latestId) return null;
  // The list from the last time the pane was open is still cached. Wait until
  // this open has loaded revisions so a just-saved version is the one selected.
  if (dataUpdatedAt <= dataUpdatedAtOnOpen) return null;
  return latestId;
};
